export const expandTransactionsList = () => {
  const expandButton = document.querySelector(
    "[data-wm-expand-transactions-wrapper]"
  );

  if (!expandButton) {
    return;
  }

  const expandTransactionsWrapper = () => {
    const wrapper = document.querySelector("[data-wm-transactions-wrapper]");
    wrapper.classList.add("expanded");
    wrapper.style.height = `calc(70px*${wrapper.dataset.wmTransactionsWrapper})`;
    document.querySelector("[data-wm-transactions-overlay]").hidden = true;
    expandButton.style.height = "0";
  };

  expandButton.addEventListener("click", expandTransactionsWrapper);
};
